export default "__VITE_ASSET__CPNiyYEC__"